import { Typography } from "PFComponents/typography";
import React from "react";

import css from "./stats_section.module.scss";

type StatColumnProps = {
  title: string;
  content: string;
};

export const StatColumn = ({ title, content }: StatColumnProps) => (
  <div className={css.statColumn}>
    <Typography variant="labelRegular" noMargin className={css.label}>
      {title}
    </Typography>
    <Typography variant="bodyButtons" noMargin>
      {content}
    </Typography>
  </div>
);
